import { getDateWithSpecificFormat } from "../../../../data-transform";

export default function customerEntityListColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach(customerEntity => {
        let row = [];
        const rowId = customerEntity.orgId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let linkDestination = null;
            let columnValue = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "orgId") {
                    columnValue = customerEntity.orgId || "";
                }
                if (columnId === "customerEntityCreationDate") {
                    columnValue = getDateWithSpecificFormat(customerEntity.createdDate) || "";
                }
            }
            else if (columnDataType === "link") {
                if (columnId === "companyName" && customerEntity.orgId) {
                    columnValue = customerEntity.companyName;
                    linkDestination = '/control-tower-settings/customer-entity-detail/' + customerEntity.orgId;
                }
            }
            
            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    linkDestination: linkDestination,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, rowId) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
